import React from 'react';
import { useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { getCartThresholdDisplayItems } from '../../../constants/cartDiscountTierConfig';
import ThresholdChipsSummary from './ThresholdChipsSummary';

const CartDiscountTierSummary = ({ rule, currency, compact, tableView = false }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const useCompact = tableView ? false : (compact ?? isMobile);
    const items = getCartThresholdDisplayItems(rule, currency, { compactMin: tableView });

    return (
        <ThresholdChipsSummary items={items} compact={useCompact} tableView={tableView} />
    );
};

export default CartDiscountTierSummary;
